import Vue from 'vue'
import Vuex from 'vuex'



Vue.use(Vuex)

const store = () => new Vuex.Store({
  state: {
    token: {}, //总站token用于获取社区的用户信息
    userInfo: {}, //用户信息
    isLogin: false, //是否登录
    report: false, //投诉模态框状态
    complaint_source: '', //投诉类型 1作品图片2作品视频3资讯4课程5帖子图片6帖子视频7作品评论8帖子评论9课程评论
    complaint_source_id: '', //投诉类型对应的id
    messageInfo: [], //notice_count_1 点赞 notice_count_2 评论 notice_count_3 关注 notice_count_4系统 notice_count_5@消息 notice_count_6 系统活动
    locales: ['ar', 'cz', 'de', 'en', 'es', 'fr', 'id', 'it', 'jp', 'kr', 'pl', 'pt', 'ru', 'sk', 'ta', 'tw', 'yn', 'zh'],
    locale: 'en',
    carouselIndex: 0, //轮播图索引
    searchKeyword: '', //全局搜索关键字
    siteConfig: {}, //站点配置（全局缓存）
    authModalRequest: null, //全局登录弹窗请求
    authModalNonce: 0, //触发全局登录弹窗的计数器
    pointToken: '', //积分系统token
    pointDetail: {}, //积分详情缓存
    pointDetailLoaded: false, //积分详情是否已加载
  },
  mutations: {
    SETTOKEN(state, info) {
      //总站Token
      state.token = info
    },
    USER_INFO(state, info) {
      //设置用户信息
      state.userInfo = info
    },
    SIGNOUT(state, info) {
      //退出登录清空数据
      state.complaint_source = state.complaint_source_id = ''
      state.token = state.userInfo = {}
      state.isLogin = state.report = false
      state.pointToken = ''
      state.pointDetail = {}
      state.pointDetailLoaded = false
      this.$cookies.remove('SSOTOKEN')
      this.$cookies.remove('lastVerifiedTime')
      this.$cookies.remove('PHPSESSID')
    },
    OPEN_REPORT_DIALOG(state, info) {
      //打开投诉模态框
      state.complaint_source = info.complaint_source
      state.complaint_source_id = info.complaint_source_id
      state.report = true
    },
    CLOSE_REPORT_DIALOG(state, info) {
      //关闭投诉模态框
      state.complaint_source = state.complaint_source_id = ''
      state.report = false
    },
    ISLOGIN(state, info) {
      //设置登录状态
      state.isLogin = info
    },
    MESSAGEINFO(state, info) {
      //消息数量
      state.messageInfo = info


    },
    SET_LANG(state, locale) {
      // 设置语言
      if (state.locales.indexOf(locale) !== -1) {
        state.locale = locale
      }
    },
    SET_CAROUSEL_index(state, info) {
      //设置作品轮播图索引
      state.carouselIndex = info
    },
    SET_SITE_CONFIG(state, info) {
      state.siteConfig = info || {}
    },
    OPEN_AUTH_MODAL(state, info = {}) {
      state.authModalRequest = {
        tab: info.tab || 'login',
        email: info.email || '',
        source: info.source || '',
        redirectToUserCenter: info.redirectToUserCenter !== false,
      }
      state.authModalNonce += 1
    },
    SET_POINT_TOKEN(state, token) {
      state.pointToken = token || ''
    },
    SET_POINT_DETAIL(state, detail) {
      state.pointDetail = detail || {}
      state.pointDetailLoaded = true
    },
    CLEAR_POINT_CACHE(state) {
      state.pointToken = ''
      state.pointDetail = {}
      state.pointDetailLoaded = false
    }
  },
  actions: {
    async nuxtServerInit({ commit }, { req, app, route, store }) {
      if (process.server && app.$cookies.get('SSOTOKEN')) {
        commit('ISLOGIN', true);
      }

      if (process.server) {
        try {
          const res = await app.$global.siteConfig()
          if (res && res.code === 200) {
            commit('SET_SITE_CONFIG', res.data.site_config || {})
          }
        } catch (error) {
          // 站点配置失败不阻塞 SSR，页面使用默认值
          commit('SET_SITE_CONFIG', {})
        }
      }
    },
  }
})

export default store
